import {api} from "../../../../../services";
import {useRegionSync} from "../../../../../hooks";
import {useAppContext, useUserContext, useBehavioralContext} from "../../../../../contexts";

export const useContent = (props) => {
    // Destructured props
    const {
        sidebarCartData,
        handleCart
    } = props;

    // Region desync recovery (PEC-509) — realign the store cookie + reload once.
    const recoverRegionSync = useRegionSync();

    // Retrieves the method to activate the full page loader component
    const {setFullPageLoader} = useAppContext();

    // eslint-disable-next-line no-unused-vars
    const [{}, {}, {
        cartData,
        setCartData
    }] = useUserContext();

    // Retrieves the method to trigger the new item alert component
    const {handleNewItemAlertStatus} = useBehavioralContext();

    // Method to add the item to the cart
    const addToCart = async () => {
        try {
            // Destructured new product data
            const {
                formKey,
                product,
                variants
            } = sidebarCartData.newProductData.productData;

            // Activates the cart loader
            setFullPageLoader(true);

            // The data to be sent in the payload
            const data = {
                formKey,
                product: product.id,
                stockId: variants.find(variant => {
                    return variant.name === sidebarCartData.lastWarehouseAdded.data.label;
                }).id,
                amount: sidebarCartData.newProductData.selectedAmount,
                ...(sidebarCartData.lastWarehouseAdded?.type === "home_delivery" && {
                    zipCode: sidebarCartData.lastWarehouseAdded.data.zipCode
                })
            }

            // Tries to post data to the backend
            let response = await api.post("/v1/cart/add", data);

            // Region desync (PEC-509): the page rendered units of another
            // regional than the server session. Realign and reload once.
            if (response.data.reason === "unit_region_mismatch") {
                await recoverRegionSync();
                return;
            }

            // Checks if there was any error during the process
            if (response.data.error) {
                console.error("Error code:", response.data.code);

                // setErrors(true);
                // setErrorMessage(response.data.message);

                return;
            }

            // setErrors(false);
            // setErrorMessage("");

            // Updates the cart items amount
            setCartData(prevState => {
                return {
                    ...prevState,
                    qtyItems: response.data.qtyItems
                }
            })

            // handleAddProductEvent(getProductGTMData);

            handleNewItemAlertStatus({
                isOpen:      true,
                productName: product.name
            });

            // Closes the modal
            handleCart("_", "_", {
                isOpen:                   false,
                isSameWarehouseModalOpen: false,
                modalBypass:              false
            });

            const timer = setTimeout(() => {
                handleCart("_", "_", {
                    url:                      "",
                    newProductData:           {},
                });

                clearTimeout(timer);
            }, 700);
        } catch (err) {
            console.error("Error while adding item to cart:", err);
        } finally {
            // Deactivates the cart loader in case of failure
            setFullPageLoader(false);
        }
    }

    const handleApproval = () => {
        addToCart().then();
    }

    return {
        handleApproval
    }
}
